export default __webpack_public_path__ + "static/media/pic8.5d8923c5.jpg";